// import { pushToDataLayer } from '@domain-group/fe-helper';
import { sendToMixpanel } from '../mixpanel';
import { SearchTypeView, SearchAgentType } from './enums';
import getEntryPoint from '../get-entry-point';

export interface ViewSearchResultsProps {
  suburb?: string | null;
  searchTypeView?: SearchTypeView;
  searchSortBy?: string;
  searchFilterSuburb?: string[];
  searchFilterAgentType?: SearchAgentType;
  searchResultsReturnedCount?: number;
}

/**
 * Track View FAA Search Results event
 * Captures granular search criteria and results information
 */
function trackViewSearchResultsPage(props: ViewSearchResultsProps = {}): void {
  const {
    suburb,
    searchTypeView,
    searchSortBy,
    searchFilterSuburb = [],
    searchFilterAgentType,
    searchResultsReturnedCount,
  } = props;

  const entryPoint = getEntryPoint();

  // Build event properties with conditional properties
  const eventProps = {
    siteSection: 'Agents',
    ...(entryPoint && { entryPoint }),
    ...(suburb && { suburb }),
    ...(searchTypeView && { searchTypeView }),
    ...(searchSortBy && { searchSortBy }),
    ...(searchFilterSuburb.length > 0 && { searchFilterSuburb }),
    ...(searchFilterAgentType && { searchFilterAgentType }),
    ...(typeof searchResultsReturnedCount === 'number' && {
      searchResultsReturnedCount,
    }),
  };

  // MixPanel page view (base props include lastTouchUTM* from mixpanel.ts getBaseProps)
  sendToMixpanel('View FAA Search Results', eventProps);

  // Google Analytics page view
  // pushToDataLayer({
  //   event: 'GAvirtualpageview',
  // });
}

export default trackViewSearchResultsPage;
